import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.primary.main,
    marginBottom: "16px",
    fontWeight: "bold",
  },
}));

export default function CustomDatePicker({
  title,
  value,
  setValue,
  updateWithVal,
}) {
  const classes = useStyles();

  const convertDate = (date, format = value.format) => {
    let object = { date, format };
    if (updateWithVal) {
      updateWithVal({
        gregorian: new DateObject(object)
          .convert(gregorian, gregorian_en)
          .format(),
        ...object,
      });
    } else {
      setValue({
        gregorian: new DateObject(object)
          .convert(gregorian, gregorian_en)
          .format(),
        ...object,
      });
    }
  };
  return (
    <>
      <Typography className={classes.title}>{title}</Typography>
      <DatePicker
        containerClassName="custom-container"
        id="galleryPicker"
        calendar={persian}
        locale={persian_fa}
        calendarPosition="top-right"
        value={value.date}
        onChange={convertDate}
        format="HH:mm:ss   YYYY/MM/DD"
        plugins={[<TimePicker position="right" />]}
      />
    </>
  );
}
